import { api } from '@/lib/api/client';
import { AdminAuditAction } from '@shared/enums/domain.enum';
import type { AdminAuditLogListResponse } from '@shared/types/entities';

import { buildQuery } from './types';

export interface GetAdminAuditLogsParams {
  page: number;
  limit: number;
  action?: AdminAuditAction;
}

/** Endpoint SUPER_ADMIN — token injecté automatiquement par le client. */
export async function getAdminAuditLogsApi(params: GetAdminAuditLogsParams): Promise<AdminAuditLogListResponse> {
  return api.get(`/admin/audit-logs${buildQuery(params as unknown as Record<string, unknown>)}`);
}
